var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHammerStrengthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 73.9596 30.0002",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hammer_Strength_Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.2707 17.1363C73.2707 16.8535 73.1016 16.729 72.7588 16.729H72.2067V18.1628H72.4254V17.5405H72.6782L73.0629 18.1628H73.3079L72.8969 17.5312C73.1094 17.5051 73.2722 17.3929 73.2722 17.1378L73.2707 17.1363ZM72.4238 17.356V16.9134H72.7247C72.8783 16.9134 73.0427 16.9457 73.0427 17.124C73.0427 17.3437 72.8752 17.356 72.6891 17.356H72.4254H72.4238Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M72.6909 16.1991C72.0007 16.1991 71.4175 16.7293 71.4175 17.4408C71.4175 18.1523 72.0007 18.6856 72.6909 18.6856C73.3811 18.6856 73.9596 18.1615 73.9596 17.4408C73.9596 16.72 73.3764 16.1991 72.6909 16.1991ZM72.6909 18.4812C72.117 18.4812 71.6703 18.0401 71.6703 17.4423C71.6703 16.8445 72.1155 16.405 72.6909 16.405C73.2663 16.405 73.7053 16.8537 73.7053 17.4423C73.7053 18.0309 73.2586 18.4812 72.6909 18.4812Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.22067 19.3496H9.12841V29.6705H12.3762V19.3496H14.284V16.1808H7.22067V19.3496Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M61.0468 16.1808H53.982V19.3511H55.8913V29.6705H59.1375V19.3511H61.0468V16.1808Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.1086 19.7542L35.3893 16.1766H32.3664V29.6802H35.3893V20.5779L39.1086 24.197V29.6802H42.1316V16.1766H39.1086V19.7542Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M67.5187 21.3443H64.9145V16.1808H61.7101V21.3428H60.9051L61.7101 24.5208V29.6828H64.9145V24.5193H67.5187V29.6859H70.723V16.1808H67.5187V21.3443Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.8695 24.5206L31.0785 21.3594H27.5174V19.3478H31.6663V16.1744H24.313V21.3594H23.7872C23.7019 18.5733 21.4684 16.3281 18.6704 16.1836L14.9836 16.1698V29.6733H18.1337V26.4784L20.2183 29.6733H23.9113L21.3583 25.7669C22.7294 25.0231 23.5204 23.9043 23.7158 22.3937L24.3145 24.5083V29.678H31.6679V26.5045H27.5189V24.5129L31.871 24.519L31.8695 24.5206ZM18.7324 23.5739H18.1322V19.3447H18.7309C19.8833 19.3447 20.817 20.402 20.817 21.5423C20.817 22.6826 19.8833 23.5739 18.7324 23.5739Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M42.6996 22.7959C42.6996 22.7959 42.6826 30.0002 50.2112 30.0002C51.3233 30.0002 52.1453 29.971 53.3117 29.6498V21.4558H50.1181V26.4272C50.1181 26.4272 46.3445 26.5025 46.3445 22.8281C46.3445 17.494 53.3101 19.3643 53.3101 19.3643V16.2031C52.4353 15.9649 51.3341 15.8113 50.0949 15.7851C42.4143 15.6299 42.6965 22.7959 42.6965 22.7959H42.6996Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.28899 15.8926C5.76981 15.9495 6.17773 16.0447 6.5143 16.1492V19.3688C4.89039 19.0722 4.27309 19.2443 3.95823 19.6085C3.53016 20.1018 3.88224 20.6274 4.1971 20.9117L6.22426 22.2901C7.26964 23.1492 7.84352 24.1466 7.84197 25.3114C7.83266 30.2506 3.04469 29.9786 3.04469 29.9786C1.95898 29.9786 1.02372 29.8203 0.131885 29.6866V26.4548C2.10787 26.6853 3.88068 27.1709 4.03579 25.5988C3.99081 24.0774 2.65384 23.9422 1.40373 22.9786C1.40373 22.9786 0.0915719 21.9398 0.00936836 20.3108C0.00936836 20.3108 -0.203129 18.3084 1.39596 17.0006C2.05359 16.4627 2.89269 16.0032 3.8233 15.8757C3.8233 15.8757 4.50883 15.7835 5.28744 15.8941L5.28899 15.8926Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M50.0992 13.9959H57.4525V10.8224H53.3036V8.83078L57.6557 8.83847L56.8647 5.67734H53.3036V3.66571H57.4525V0.492292H50.0992V5.67734H49.3082L50.0992 8.82617V13.9959Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M61.3043 10.8009L63.3888 13.9959H67.0818L64.5288 10.0894C66.2055 9.17963 66.9623 7.87184 66.9623 5.84638C66.9623 2.98493 64.6932 0.653652 61.8425 0.506122L58.1557 0.492292V13.9959H61.3058V10.8009H61.3043ZM61.3043 3.66571H61.9029C63.0553 3.66571 63.9891 4.72301 63.9891 5.86329C63.9891 7.00357 63.0553 7.89489 61.9045 7.89489H61.3043V3.66571Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M40.6921 7.26789L43.1195 11.9397L45.5375 7.28326L46.2665 13.9959H49.4833L48.0051 0.492292H45.7081L43.1195 5.68195L40.5603 0.492292H38.2322L36.7448 13.9959H39.9616L40.6921 7.26789Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M36.223 13.9959L34.7433 0.492292H32.4463L29.8577 5.68195L27.2985 0.492292H24.972L23.483 13.9959H26.6998L27.4319 7.26789L29.8577 11.9397L32.2757 7.28326L33.0047 13.9959H36.223Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M4.12309 17.5181L7.32746 13.9928V8.8231H9.93161V13.9959H13.136V6.34583V5.66197V0.492292H9.93161V5.66505H7.32746V0.492292H4.12309V17.5181Z",
    fill: "var(--fill-0, #211414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M13.8825 8.80874V13.9953H17.1071V8.80721H19.7236V13.9953H22.928V4.47967C22.928 2.00548 20.9039 0 18.4053 0C15.9066 0 13.8825 2.00548 13.8825 4.47967V5.6553H13.017L13.8825 8.80874ZM17.1055 4.46584C17.1055 3.74971 17.6918 3.17035 18.4146 3.17035C19.1373 3.17035 19.7236 3.75125 19.7236 4.46584V5.64762H17.1071V4.46584H17.1055Z",
    fill: "var(--fill-0, #211414)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammerStrengthLogo);
export default __webpack_public_path__ + "static/media/hammer_strength_logo.8e94df9202e1aea8540708c7df854d21.svg";
export { ForwardRef as ReactComponent };